<script>
import { componentStore } from "@common/componentStore/componentStore.js";
import { ddStore } from "@common/ddStore";

const foldersManagerCfg = {
    cId: "foldersManager",
    cType: "foldersManager",
    cTitle: "foldersManager Component",
    cTemplate: `<div class="folder-area" :id="cId + '_wrapper'">
                    <control name="ACTIONS" :items="actionItems"></control>
                    <div v-for="(option, index) in foldersList" :key="index" class="folder">
                        <div v-if="option.VIEW_TYPE_ID !== ghostViewTypeId || selectedFolder.VIEW_TYPE_ID === binViewTypeId || selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId">
                            <div class="folder-icons">
                                <a :class="{'fh': true, 'hidden-icon': hideIconOut(option), 'visible-icon': !hideIconOut(option)}" href="javascript:void(0)" @click="moveOutFolder(option);">
                                    <span class="folder-core-img img_moveout" :class="{'fh': true, 'hidden-icon': hideIconOut(option), 'visible-icon': !hideIconOut(option)}" title="Move selected records out of this folder" >
                                        <i class="material-icons mi-chevron-left">chevron_left</i>
                                    </span>
                                </a>
                                <a :class="{'fh': true, 'hidden-icon': hideIconIn(option), 'visible-icon': !hideIconIn(option)}" href="javascript:void(0)" @click="moveInFolder(option);">
                                    <span class="folder-core-img img_movein" :class="{'fh': true, 'hidden-icon': hideIconIn(option), 'visible-icon': !hideIconIn(option)}" title="Move selected records into this folder" >
                                        <i class="material-icons mi-chevron-right">chevron_right</i>
                                    </span>
                                </a>
                                <a v-if="option.view_type != binViewTypeId && option.view_type != 3 && option.VIEW_TYPE_ID != ghostViewTypeId && option.VIEW_TYPE_ID != oppViewTypeId && option.VIEW_TYPE_ID != archiveViewTypeId" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);">
                                    <img v-if="selectedFolder.DATA_VIEW_ID !== option.DATA_VIEW_ID" :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder.gif'">
                                    <img v-if="selectedFolder.DATA_VIEW_ID === option.DATA_VIEW_ID" :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_sel.gif'">
                                </a>
                                <a v-if="option.view_type == 3" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);" id="folder_AllDataFolder">
                                    <img :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_all_sel.gif'">
                                </a>
                                <a v-if="option.view_type == binViewTypeId" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);" id="folder_RecycleBin">
                                    <img :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_trash_full.gif'">
                                </a>
                                <a v-if="option.VIEW_TYPE_ID == ghostViewTypeId" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);" :id="'folder_' + option.DATA_VIEW_NAME">
                                    <img :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_ghost.gif'">
                                </a>
                                <a v-if="option.VIEW_TYPE_ID == archiveViewTypeId" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);" :id="'folder_' + option.DATA_VIEW_NAME">
                                    <img v-if="selectedFolder.DATA_VIEW_ID !== option.DATA_VIEW_ID" :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_archive.gif'">
                                    <img v-if="selectedFolder.DATA_VIEW_ID === option.DATA_VIEW_ID" :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_archive_sel.gif'">
                                </a>
                                <a v-if="option.VIEW_TYPE_ID == archiveViewTypeId" class="fh mlr" href="javascript:void(0)" @click="selectFolder(option);" :id="'folder_' + option.DATA_VIEW_NAME">
                                    <img :alt="option.DATA_VIEW_NAME" class="img_folder" :src="projectUrl + 'common/images/dataview/folder_archive.gif'">
                                </a>
                            </div>
                            <div class="folder-text">
                                <a href="javascript:void(0)" :class="{'folder-unselectedtextIE': selectedFolder.DATA_VIEW_ID !== option.DATA_VIEW_ID, 'folder-selectedtextIE': selectedFolder.DATA_VIEW_ID === option.DATA_VIEW_ID}" @click="selectFolder(option);" :title="option.DATA_VIEW_NAME">
                                    {{option.DATA_VIEW_NAME}}
                                </a>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'ACTIONS',
            title: 'Folder Manager',
            type: 'dropdownbutton',
            fields: { text: 'label', value: 'value' },
            onselect: 'doFolderAction',
            label: 'Folder Manager',
        },
    ]
};

const editorConfig = {

};

const foldersManagerCmp = {
    name: 'foldersManager',
    editorSettings: editorConfig,
    props: {
        selectedFolder: {
            default: {}
        },
        selectedItems: {
            default: false
        },
        psp: {
            default: false
        }
    },
    data() {
        return {
            ghostViewTypeId: 8,
            binViewTypeId: 6,
            oppViewTypeId: -1, // ????,
            archiveViewTypeId: -1, // ????
        };
    },
    computed: {
        foldersList() {
            let foldersList = store.state.configStore.cfg.folders[this.psp];
            return foldersList;
        },
        projectUrl() {
            let projectUrl = '/';
            if (typeof PROJECTS_URL !== 'undefined') projectUrl = PROJECTS_URL;
            return projectUrl;
        },
        actionItems() {
            let actions = [];
            if (this.selectedFolder && this.selectedFolder.VIEW_TYPE_ID !== this.ghostViewTypeId) {
                actions.push({ text: 'New', value: 'newFolder' });
            }
            if (this.selectedFolder && (this.selectedFolder.view_type === 5 || this.selectedFolder.view_type === 4)) {
                actions.push({ text: 'Edit', value: 'editFolder' });
                actions.push({ text: 'Delete', value: 'deleteFolder' });
            }
            if (this.selectedFolder && this.selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId) {
                actions.push({ text: 'Restore', value: 'restoreFolder' });
                actions.push({ text: 'Delete', value: 'deleteFolder' });
            }
            return actions;
        },
    },
    methods: {
        hideIconIn(folder) {
            let hideIconIn = false;
            if (!this.selectedItems || !this.selectedItems.length
                || folder.VIEW_TYPE_ID === this.binViewTypeId
                || folder.VIEW_TYPE_ID === 3
                || (
                    this.selectedItems
                    && this.selectedItems.length === 1
                    && this.selectedItems[0].folders
                    && this.selectedItems[0].folders.indexOf(folder.DATA_VIEW_ID) !== -1
                )) {
                hideIconIn = true;
            }
            if (this.selectedFolder && (this.selectedFolder.VIEW_TYPE_ID === this.binViewTypeId || this.selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId)) {
                hideIconIn = true;
            }
            return hideIconIn;
        },
        hideIconOut(folder) {
            let hideIconOut = false;
            if (!this.selectedItems || !this.selectedItems.length
                || folder.VIEW_TYPE_ID === this.binViewTypeId
                || folder.VIEW_TYPE_ID === 3
                || (
                    this.selectedItems
                    && this.selectedItems.length === 1
                    && this.selectedItems[0].folders
                    && this.selectedItems[0].folders.indexOf(folder.DATA_VIEW_ID) === -1
                )) {
                hideIconOut = true;
            }
            if (this.selectedFolder && (this.selectedFolder.VIEW_TYPE_ID === this.binViewTypeId || this.selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId)) {
                hideIconOut = true;
            }
            return hideIconOut;
        },
        async onLoad() {
            ddStore.preloadGroup('DATA_GRID');
            ddStore.preloadGroup('DATA_GRID');
            ddStore.preloadGroup('COMMON');
            library.showLoadingIndicator(this.cId + '_wrapper');
            await configStore.getFolders(this.psp);
            library.hideLoadingIndicator(this.cId + '_wrapper');
        },
        async onPropsUpdate() {
            // debugger;
        },
        async reload() {
            library.showLoadingIndicator(this.cId + '_wrapper');
            await configStore.getFolders(this.psp, true);
            library.hideLoadingIndicator(this.cId + '_wrapper');
        },
        selectFolder(folder) {
            this.selectedFolder = folder;
            this.$emit('update:propSelectedFolder', this.selectedFolder);
        },
        selectFolderById(id) {
            if (this.foldersList && this.foldersList.length) {
                let folder = this.foldersList.find((tmpFolder) => tmpFolder.DATA_VIEW_ID === id);
                if (folder) {
                    this.selectedFolder = folder;
                    this.$emit('update:propSelectedFolder', this.selectedFolder);
                }
            }
        },
        selectRecycleBin() {
            for (let i in this.foldersList) {
                if (i === 'length') continue;
                if (this.foldersList[i].VIEW_TYPE_ID === this.binViewTypeId) {
                    this.selectedFolder = library.cloneObj(this.foldersList[i]);
                    this.$emit('update:propSelectedFolder', this.selectedFolder);
                }
            }
        },
        async moveOutFolder(folder, woCheck) {
            let selectedItems = [];
            let selectedFolder = folder.DATA_VIEW_ID || false;
            let psp = parseInt(this.psp, 10) || false;
            for (let i in this.selectedItems) {
                if (i === 'length') continue;
                selectedItems.push(this.selectedItems[i].rowID);
            }
            if (selectedItems.length && selectedFolder && psp) {
                let needWarning = false;
                for (let i in this.selectedItems) {
                    if (i === 'length') continue;
                    let tmpFolders = library.cloneObj(this.selectedItems[i].folders);
                    const index = tmpFolders.indexOf(selectedFolder);
                    if (index > -1) {
                        tmpFolders.splice(index, 1);
                    }
                    if (!tmpFolders.length) {
                        needWarning = true;
                    }
                }
                if (needWarning && !woCheck) {
                    let multi = this.selectedItems.length > 1;
                    let availability = this.psp === 1 ? await ddStore.getAlias('DATA_GRID', 'FOLDERCORE_DELETE_AVAILABLE') : '';
                    let message = await ddStore.getAlias('DATA_GRID', 'FOLDERCORE_DELETE_CONFIRM' + (multi ? '_MULTI' : ''), availability);
                    let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                    let opt = {
                        name: 'confirmMoveOut',
                        title: title
                    };
                    library.showDialog(message, () => {
                        this.moveOutFolder(folder, true);
                    },
                    false,
                    opt);
                    return;
                }
                library.showLoadingIndicator(this.cId + '_wrapper');
                let result = await this.sDs.post('ec_removeRecordFromFolder', psp, selectedItems, selectedFolder);
                library.hideLoadingIndicator(this.cId + '_wrapper');
                if (result && result.status === 'success') {
                    for (let i in this.selectedItems) {
                        if (i === 'length') continue;
                        if (this.selectedItems[i].folders) {
                            const index = this.selectedItems[i].folders.indexOf(selectedFolder);
                            if (index > -1) {
                                this.selectedItems[i].folders.splice(index, 1);
                            }
                        }
                    }
                }
            }
        },
        async moveInFolder(folder) {
            let selectedItems = [];
            let selectedFolder = folder.DATA_VIEW_ID || false;
            let psp = parseInt(this.psp, 10) || false;
            for (let i in this.selectedItems) {
                if (i === 'length') continue;
                selectedItems.push(this.selectedItems[i].rowID);
            }
            if (selectedItems.length && selectedFolder && psp) {
                library.showLoadingIndicator(this.cId + '_wrapper');
                let result = await this.sDs.post('ec_addRecordToFolder', psp, selectedItems, selectedFolder);
                library.hideLoadingIndicator(this.cId + '_wrapper');
                if (result && result.status === 'success') {
                    for (let i in this.selectedItems) {
                        if (i === 'length') continue;
                        if (this.selectedItems[i].folders) {
                            this.selectedItems[i].folders.push(selectedFolder);
                        }
                    }
                }
            }
        },
        async deleteFolder() {
            if (this.selectedFolder) {
                let entity = await ddStore.getAlias('COMMON', 'ENTITY_FOLDER');
                let isPermanentDelete = this.selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId;
                let messageLabel = isPermanentDelete ? 'ERRORMESSAGE_DELETE_PERMANENTLY' : 'ERRORMESSAGE_DELETE';
                let message = await ddStore.getAlias('COMMON', messageLabel, entity);
                let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                let opt = {
                    name: 'deleteFolder',
                    title: title
                };
                library.showDialog(message, () => {
                    library.showLoadingIndicator(this.cId + '_wrapper');
                    this.sDs.post('ec_deleteFolder', this.selectedFolder.DATA_VIEW_ID).then((response) => {
                        library.hideLoadingIndicator(this.cId + '_wrapper');
                        if (response && response.status === 'success') {
                            if (isPermanentDelete) this.selectRecycleBin();
                            this.onLoad();
                        } else if (response && response.error) {
                            let message = response.error;
                            if (Array.isArray(message)) message = message.join('<br>');
                            library.showDialog(message, false, false, { showAsAlert: true });
                        }
                    });
                },
                false,
                opt);
            }
        },
        async restoreFolder() {
            if (this.selectedFolder && this.selectedFolder.VIEW_TYPE_ID === this.ghostViewTypeId) {
                let message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_FOLDER_RESTORE');
                let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_FOLDER_RESTORE_TITLE');
                let opt = {
                    name: 'restoreFolder',
                    title: title
                };
                library.showDialog(message, () => {
                    library.showLoadingIndicator(this.cId + '_wrapper');
                    this.sDs.post('ec_restoreFolder', this.selectedFolder.DATA_VIEW_ID).then((response) => {
                        library.hideLoadingIndicator(this.cId + '_wrapper');
                        if (response && response.status === 'success') {
                            this.onLoad();
                        } else if (response && response.error) {
                            let message = response.error;
                            if (Array.isArray(message)) message = message.join('<br>');
                            library.showDialog(message, false, false, { showAsAlert: true });
                        }
                    });
                },
                false,
                opt);
            }
        },
        doFolderAction(event) {
            if (this.selectedFolder && event && event.item && event.item.value) {
                let act = event.item.value;
                let params;
                switch (act) {
                    case 'deleteFolder':
                        this.deleteFolder();
                        break;
                    case 'restoreFolder':
                        this.restoreFolder();
                        break;
                    default:
                        params = {
                            actVal: act,
                            openInSameWindow: true,
                            recordId: this.selectedFolder.DATA_VIEW_ID,
                            isMainGrid: true,
                            doLocalAction: this.reload
                        };
                        actionStore.actions.iframeProcessSubmit(act, params, 800, 600);
                        break;
                }
            }
        }
    }
};

componentStore.initComponent(foldersManagerCmp, foldersManagerCfg);
export { foldersManagerCfg, foldersManagerCmp };
export default foldersManagerCmp;
</script>

<style scoped>
:deep(.folder-area) {
    background: #fff;
}

:deep(.folder) {
    padding: 0 10px 0 0;
}

:deep(.folder-item) {
    margin-right:5px;
}

:deep(.folder-icons) {
    width: 50px;
    float: left;
}

:deep(.folder-icons .mlr) {
    margin-left: 6px;
}

:deep(.folder-icons .mlr img) {
    padding-top: 0px !important;
    padding-bottom: 6px !important;
}

:deep(.folder-text) {
    width: 70px;
    float: left;
    overflow: hidden;
    white-space: nowrap;
}

:deep(.hidden-icon) {
    visibility: hidden !important;
}

:deep(.visible-icon) {
    visibility: visible !important;
}

:deep([name=ACTIONS]) {
    width: 135px !important;
    height: 30px !important;
    border: none !important;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    box-shadow: none !important;
    margin: 0 !important;
    background-color: transparent !important;
}
</style>
